import React from 'react'
import { Link } from 'gatsby'
import { StaticQuery, graphql } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'

import cosmicjsLogo from '../../static/cosmicjs.svg'
import gatsbyLogo from '../../static/gatsby.png'
import { rhythm, scale } from '../utils/typography'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

export default ({ children, location }) => (
  <StaticQuery
    query={graphql`query LayoutQuery {
  cosmicjsSettings(slug: {eq: "general"}) {
    metadata {
      homepage_hero {
          gatsbyImageData(
            formats: JPG,
            placeholder: DOMINANT_COLOR
          )
      }
    }
  }
}`}
    render={data => {
      const homgePageHero = getImage(data.cosmicjsSettings.metadata.homepage_hero.gatsbyImageData)
      const bghomgePageHero = convertToBgImage(homgePageHero)
      let header

      let rootPath = `/`
      let postsPath = `/posts`
      let contactPath = `/contact`
      if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
        rootPath = __PATH_PREFIX__ + `/`
        postsPath = __PATH_PREFIX__ + `/posts`
        contactPath = __PATH_PREFIX__ + `/contact`
      }

      if (location.pathname.endsWith('/')){
        postsPath = postsPath + `/`
        contactPath = contactPath + `/`
      }

      if (location.pathname === rootPath || location.pathname === postsPath || location.pathname === contactPath) {
        header = (
          <BackgroundImage
            Tag="div"
            className="post-hero"
            {...bghomgePageHero}
            backgroundColor={`#007ACC`}
            style={{
              height: rhythm(12),
              position: 'relative',
              marginBottom: `${rhythm(1.5)}`,
            }}
          >
          </BackgroundImage>
        )
      } else {
        <div></div>
      }
      return (
        <div>
          {header}
          <div
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              maxWidth: rhythm(44),
              padding: `0 ${rhythm(3 / 4)} ${rhythm(1.5)} ${rhythm(3 / 4)}`,
              minHeight: 'calc(100vh - 42px)',
            }}
          >
            {children}
          </div>
          <footer
            style={{
              textAlign: 'center',
              padding: `120px 20px`,
            }}
          >
            <div>
            <strong style={{
                  fontSize: '10pt',
                  }}>powered by&nbsp;</strong>
              <a
                target="_blank"
                href="https://gatsbyjs.org"
                style={{
                  color: '#191919',
                  boxShadow: 'none',
                  fontSize: '10pt',
                }}
              >
                <img
                  src={gatsbyLogo}
                  alt="Gatsby JS"
                  style={{
                    width: '18px',
                    margin: '0 4px -3px 2px',
                  }}
                />
                <strong >Gatsby</strong>
              </a>
              <strong style={{
                  fontSize: '10pt',
                  }}>&nbsp;and&nbsp;</strong>
              <a
                target="_blank"
                href="https://cosmicjs.com"
                style={{
                  color: '#191919',
                  boxShadow: 'none',
                  fontSize: '10pt'
                }}
              >
                <img
                  src={cosmicjsLogo}
                  alt="Cosmic JS"
                  style={{
                    width: '16px',
                    margin: '0 4px -2px 5px',
                  }}
                />
                <strong>Cosmic JS</strong>
              </a>
            </div>
          </footer>
        </div>
      )
    }}
  />
)
